import React, {useState} from 'react';
import styles from './Header.css';
import logo from '../../images/logo-bookmark.svg';
import {  AiOutlineGoogle } from 'react-icons/ai';
import {  GrFacebookOption } from 'react-icons/gr';


export default function Header() {

  //========================== EMAIL VALIDATION CHECK ============================
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [showLoginForm, setLoginForm] = useState(false);
  const handleLoginButtonClick = () => {
    setLoginForm(true)
  }
  
  const handleLoginButtonClickMouseleave = () => {
    setLoginForm(true)
  }

  const handleEmailChange = (event) => {
    const inputEmail = event.target.value;
    setEmail(inputEmail);
    setIsValidEmail(emailPattern.test(inputEmail));
  };

  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  // ==================================================================================================================================

  // ========= PASSWORD CHECK ===========
  const [password, setPassword] = useState('');
  const [isPasswordValid, setIsPasswordValid] = useState(true);

  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setPassword(newPassword);
    setIsPasswordValid(newPassword.length >= 6);
  };
  

  return (
    <div className='Header'>
    <div className='Navbar'>
      <div><img src={logo} alt="main logo" /></div>
         <ul className='nav-item'>
           <li className='nav-list'>
             <a href='#features'>features</a>
           </li>
           <li className='nav-list'>
             <a href='#download'>Pricing</a>
           </li>
           <li className='nav-list'>
             <a href='#contact'>Contact</a>
           </li>
           <div className='nav-btn'>
             <button 
             onMouseEnter={handleLoginButtonClick}
             onMouseLeave={handleLoginButtonClickMouseleave}>
              login
             </button>
             {showLoginForm && (
              <div className={`login-form ${showLoginForm ? 'visible' : ''}`}>
                <h3>Login</h3>
                <p className='login-form-signup-text'>Doesn`t have an account yet? <a className='login-form-signup-link' href='#'>Sign Up</a></p>
                <div className={`nav-form-control ${!isValidEmail && email.trim() !== '' ? 'error-present' : ''}`}>
                  <label htmlFor="email">Email Address</label>
                  <input type="email" 
                  placeholder="you@example.com" 
                  value={email} 
                  onChange={handleEmailChange}
                  className={isValidEmail ? 'correct-email-border' : ''}/>
                  {!isValidEmail && email.trim() !== '' && ( 
                    <p className='error nav-form-error'>Email is not valid.</p>
                  )}
                </div>
                <div className="nav-form-control">
                  <label htmlFor="password">Password</label>
                  <input type="password" 
                    value={password}
                    onChange={handlePasswordChange}
                    placeholder="Enter 6 character or more"
                    className={password.length >= 6 ? 'success-border' : 'error'}
                    />
                    {!isPasswordValid && (
                      <p className='error nav-form-error'>Password must be at least 6 characters long.</p>
                    )}

                  <span className='login-form-signup-forgot-pwd-link'><a href='#' className='login-form-signup-link'>Forgot Password?</a></span>
                </div>
                <div className="nav-form-control checkbox-container">
                  <input type="checkbox" />
                  <span className='checkbox-text'>Remember me</span>
                </div>

                <div className="nav-form-control">
                  <div className='login-form-btn'>Login</div>
                </div>

                <div className="login-form-option">
                  <span>-------- or login with ---------</span>
                  <div className="login-choice-container">
                    <div className="login-choice google">
                       <AiOutlineGoogle  style={{ fontSize: '1.04rem' }}/> Google
                       </div>
                    <div className="login-choice facebook">
                      <GrFacebookOption style={{ fontSize: '1.04rem' }}/>Facebook
                      </div>
                  </div>
                </div>

              </div>
            )}
         </div>
         </ul> 
    </div>
 </div>
)
  
}

